<style lang="less" scoped>

  .article-qr-code {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #e6e6e6;
    height: 350px;
    position: relative;

    h5 {
      color: #000;
      font-size: 18px;
      font-weight: normal;
      text-align: center;
      margin-top: 30px;
    }

    p {
      color: #9f9f9f;
      font-size: 14px;
      text-align: center;
      margin-top: 20px;
    }

    .con-r-one-tl {
      position: absolute;
      top: 10px;
      left: -7px;
      transform: rotate(270deg);
      transform-origin: top right;
    }

    .con-r-one-tr {
      position: absolute;
      top: 10px;
      left: 306px;
    }

    .con-r-one-bl {
      position: absolute;
      top: 338px;
      left: -7px;
      transform: rotate(180deg);
      transform-origin: top right;

    }

    .con-r-one-br {
      position: absolute;
      top: 338px;
      left: 306px;
      transform: rotate(90deg);
      transform-origin: top right;
    }
    .wechat{
      width:140px;
      height:140px;
    }
    .qrcode{
      position: relative;
      width: 140px;
      height: 140px;
      margin: 28px auto;
    }
  }
  .qrcode_tl, .qrcode_bl, .qrcode_tr, .qrcode_br{
    position: absolute;

  }
  .qrcode_tl{
    top: -9px;
    left: -30px;
    transform: rotate(270deg);
    transform-origin: top right;
  }
  .qrcode_bl{
    top: 152px;
    left: -30px;
    transform: rotate(180deg);
    transform-origin: top right;
  }
  .qrcode_tr{
    top: -9px;
    left: 130px;
  }
  .qrcode_br{
    top: 152px;
    left: 130px;
    transform: rotate(90deg);
    transform-origin: top right;
  }
  .beizhu{
    font-size:12px;
    color: #2493e0;
    text-align: center;
  }
</style>
<template>
  <div class="article-qr-code">
    <div class="con-r-one-tl"><img src="//official.cdn.qiyewan.com/border---.png" alt="qrcode"></div>
    <div class="con-r-one-bl"><img src="//official.cdn.qiyewan.com/border---.png" alt="qrcode"></div>
    <div class="con-r-one-tr"><img src="//official.cdn.qiyewan.com/border---.png" alt="qrcode"></div>
    <div class="con-r-one-br"><img src="//official.cdn.qiyewan.com/border---.png" alt="qrcode"></div>
    <h5>企业湾  创业干货分享</h5>p
    <p>关注企业湾，收听和分享更多创业讯息</p>
    <div class="qrcode">
      <div class="qrcode_tl"><img src="//official.cdn.qiyewan.com/boeder---.png" alt="qrcode"></div>
      <div class="qrcode_bl"><img src="//official.cdn.qiyewan.com/boeder---.png" alt="qrcode"></div>
      <div class="qrcode_tr"><img src="//official.cdn.qiyewan.com/boeder---.png" alt="qrcode"></div>
      <div class="qrcode_br"><img src="//official.cdn.qiyewan.com/boeder---.png" alt="qrcode"></div>
      <img src="../../assets/wechat-qrcode.jpg" alt="qrcode" class="wechat">
    </div>
    <div class="beizhu">携手企业湾，为您提供中小企业<br>专业项目服务服务</div>
  </div>
</template>
<script>
  export default{
    data(){
      return {}
    },
    created(){
    },
  }
</script>



// WEBPACK FOOTER //
// QrCode.vue?0b8fbd8e